export const FETCH_ORDERS_REQUEST = 'FETCH_ORDERS_REQUEST';
export const FETCH_ORDERS_SUCCESS = 'FETCH_ORDERS_SUCCESS';
export const FETCH_ORDERS_FAILURE = 'FETCH_ORDERS_FAILURE';

export const CREATE_ORDER_REQUEST = 'CREATE_ORDER_REQUEST';
export const CREATE_ORDER_SUCCESS = 'CREATE_ORDER_SUCCESS';
export const CREATE_ORDER_FAILURE = 'CREATE_ORDER_FAILURE';

export const UPDATE_ORDER_REQUEST = 'UPDATE_ORDER_REQUEST';
export const UPDATE_ORDER_SUCCESS = 'UPDATE_ORDER_SUCCESS';
export const UPDATE_ORDER_FAILURE = 'UPDATE_ORDER_FAILURE';

export const FETCH_ORDER_BY_ID_REQUEST = 'FETCH_ORDER_BY_ID_REQUEST';
export const FETCH_ORDER_BY_ID_SUCCESS = 'FETCH_ORDER_BY_ID_SUCCESS';
export const FETCH_ORDER_BY_ID_FAILURE = 'FETCH_ORDER_BY_ID_FAILURE';



// Action Creators
export const fetchOrdersRequest = (page = 1, limit = 10) => ({
  type: FETCH_ORDERS_REQUEST,
  payload: { page, limit },
});

export const fetchOrdersSuccess = (data) => ({
  type: FETCH_ORDERS_SUCCESS,
  payload: data,
});

export const fetchOrdersFailure = (error) => ({
  type: FETCH_ORDERS_FAILURE,
  payload: error,
});

export const createOrderRequest = (order) => ({
  type: CREATE_ORDER_REQUEST,
  payload: order,
});

export const createOrderSuccess = (order) => ({
  type: CREATE_ORDER_SUCCESS,
  payload: order,
});

export const createOrderFailure = (error) => ({
  type: CREATE_ORDER_FAILURE,
  payload: error,
});

export const updateOrderRequest = (id, order) => ({
  type: UPDATE_ORDER_REQUEST,
  payload: { id, order },
});

export const updateOrderSuccess = (order) => ({
  type: UPDATE_ORDER_SUCCESS,
  payload: order,
});

export const updateOrderFailure = (error) => ({
  type: UPDATE_ORDER_FAILURE,
  payload: error,
});

export const fetchOrderByIdRequest = (id) => ({
  type: FETCH_ORDER_BY_ID_REQUEST,
  payload: id,
});

export const fetchOrderByIdSuccess = (data) => ({
  type: FETCH_ORDER_BY_ID_SUCCESS,
  payload: data,
});

export const fetchOrderByIdFailure = (error) => ({
  type: FETCH_ORDER_BY_ID_FAILURE,
  payload: error,
});

export const REDOWNLOAD_ORDER_REQUEST = 'REDOWNLOAD_ORDER_REQUEST';
export const REDOWNLOAD_ORDER_SUCCESS = 'REDOWNLOAD_ORDER_SUCCESS';
export const REDOWNLOAD_ORDER_FAILURE = 'REDOWNLOAD_ORDER_FAILURE';

export const redownloadOrderRequest = (orderId) => ({
  type: REDOWNLOAD_ORDER_REQUEST,
  payload: orderId,
});

export const redownloadOrderSuccess = (data) => ({
  type: REDOWNLOAD_ORDER_SUCCESS,
  payload: data,
});

export const redownloadOrderFailure = (error) => ({
  type: REDOWNLOAD_ORDER_FAILURE,
  payload: error,
});

export const ACCEPT_SHORTFALL_REQUEST = 'ACCEPT_SHORTFALL_REQUEST';
export const ACCEPT_SHORTFALL_SUCCESS = 'ACCEPT_SHORTFALL_SUCCESS';
export const ACCEPT_SHORTFALL_FAILURE = 'ACCEPT_SHORTFALL_FAILURE';

export const acceptShortfallRequest = (poId, itemId, reason, page = 1) => ({
  type: ACCEPT_SHORTFALL_REQUEST,
  payload: { poId, itemId, reason, page },
});

export const acceptShortfallSuccess = (data) => ({
  type: ACCEPT_SHORTFALL_SUCCESS,
  payload: data,
});

export const acceptShortfallFailure = (error) => ({
  type: ACCEPT_SHORTFALL_FAILURE,
  payload: error,
});
